import actionTypes from '../actions/action-types';

const changeMessageReadStatus = (action, status) =>
  action.messages.map((message) => {
    const isSelected = action.selectedMessagesList.includes(message.userMessageId);
    if (isSelected) return { ...message, isRead: status };
    return { ...message };
  });

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_MESSAGES_LIST_SUCCESS: {
      return [...action.messages];
    }
    case actionTypes.DELETE_MESSAGES_SUCCESS: {
      return action.messages.filter(({ userMessageId }) => {
        const isSelected = action.selectedMessagesList.includes(userMessageId);

        return !isSelected;
      });
    }
    case actionTypes.MARK_MESSAGE_AS_UNREAD_SUCCESS: {
      return changeMessageReadStatus(action, false);
    }
    case actionTypes.MARK_MESSAGE_AS_READ_SUCCESS: {
      return changeMessageReadStatus(action, true);
    }
    case actionTypes.RESET_INBOX: {
      return [];
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/message/reducers/inbox.js